import React, { type MouseEvent } from 'react';
import styles from './Table.module.css';
import { ApplicationView, useController } from '@aha-app/mvc';
import classnames from 'classnames';
import useEventHandler from '../../../components/useEventHandler';
import TableController from './TableController';

interface ColumnResizeHandleProps {
  onMove: (x: number, rowIndex: number) => void;
  rowIndex: number;
  columnIndex: number;
}
const ColumnResizeHandle: React.FC<ColumnResizeHandleProps> = ({
  onMove,
  rowIndex,
  columnIndex,
}) => {
  const controller = useController(TableController);
  const { hoveredResizeHandleIndex, draggingResizeHandleIndex } =
    controller.state;

  const hovering = hoveredResizeHandleIndex === columnIndex;
  const dragging = draggingResizeHandleIndex === columnIndex;

  const onMouseEnter = () => {
    controller.actionSetHoveredResizeHandle(columnIndex);
  };

  const onMouseLeave = () => {
    controller.actionSetHoveredResizeHandle(null);
  };

  const onMouseDown = (event: MouseEvent) => {
    controller.actionSetDraggingResizeHandle(columnIndex);

    event.stopPropagation();
    event.preventDefault();
  };

  const onMouseMove = (event: MouseEvent) => {
    if (dragging) {
      event.stopPropagation();
      event.preventDefault();

      const { clientX: x } = event;

      if (onMove) onMove(x, rowIndex);
    }
  };

  const onMouseUp = (event: MouseEvent) => {
    if (dragging) {
      controller.actionSetDraggingResizeHandle(null);

      event.stopPropagation();
      event.preventDefault();
    }
  };

  useEventHandler('mousemove', (event: MouseEvent) => onMouseMove(event));
  useEventHandler('mouseup', (event: MouseEvent) => onMouseUp(event));

  return (
    <div
      contentEditable={false}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onMouseDown={onMouseDown}
      onMouseUp={onMouseUp}
      className={classnames(styles.cellResizeHandle, {
        [styles.cellResizeHandleActive]: dragging || hovering,
      })}
    >
      <div className={styles.cellResizeHandleIndicator} />
    </div>
  );
};

export default ApplicationView(ColumnResizeHandle);
